import config from '@/config';
import { requests } from '.';
export const ProductService = {
    getProducts: (params) => requests(config.PRODUCT_SERVICE_URL).get('/products/', {
        params,
    }),
    ammountSummary: (params) => requests(config.PRODUCT_SERVICE_URL).post('/products/amount-summary', params),
};
